import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import config from '../../config'

const sleep = (t = Math.random() * 200 + 300) => new Promise(resolve => setTimeout(resolve, t))

interface InitialState {
  value: number
  loading: boolean
  error: string | null
  contentData: any
}

export const initialState: InitialState = {
  value: 0,
  loading: false,
  error: null,
  contentData: {
    langCode: '',
    title: '',
    content: {
      introduction: '',
    },
    miscData: {},
    translation: {},
  },
}

export const fetchInitial = createAsyncThunk('main/fetchInitial', async (_, {rejectWithValue}) => {
  try {
    // For demo purpose let's say out value is the length
    // of the project name in manifest and the api call is slow
    // await sleep()
    const response = await axios.get(config.api)
    return response.data
  } catch (err) {
    return rejectWithValue('Something went wrong.')
  }
})

export const slice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    increment: state => {
      state.value += 1
    },
    decrement: state => {
      state.value -= 1
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchInitial.pending, state => {
        state.loading = true
      })
      .addCase(fetchInitial.fulfilled, (state, action) => {
        state.contentData = action.payload
        state.loading = false
      })
      .addCase(fetchInitial.rejected, (state, action) => {
        // @ts-ignore
        state.error = action.payload
        state.loading = false
      })
  },
})

export const {increment, decrement} = slice.actions

export default slice.reducer
